<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Support Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">Reporting</div>
                <div class="feature-input">
                    <a-select v-model="featureForm.support" style="width: 100%">
                        <a-select-option value="basic-support">Basic Support</a-select-option>
                        <a-select-option value="7-24-support">24/7 Support</a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Other Features</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.softwareSupport">Software Support</a-checkbox>
                    <a-checkbox v-model="featureForm.dedicatedCustomerSupport">Dedicated Customer Support</a-checkbox>
                    <a-checkbox v-model="featureForm.supportWhatsappBusinessSetup">Whatsapp Business Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportFacebookSetup">Facebook Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportInstagramSetup">Instagram Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportChatbotSetup">Chatbot Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportAISetup">AI Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportAutomationSetup">Automation Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportSpecialPanelTraining">Special Panel Training</a-checkbox>
                    <a-checkbox v-model="featureForm.supportConsultancy">Consultancy</a-checkbox>
                    <a-checkbox v-model="featureForm.supportIntegrationSetup">Integration Setup</a-checkbox>
                    <a-checkbox v-model="featureForm.supportStrategyPlanning">Strategy Planning</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";
export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            support: null,
            softwareSupport: false,
            dedicatedCustomerSupport: false,
            supportWhatsappBusinessSetup: false,
            supportFacebookSetup: false,
            supportInstagramSetup: false,
            supportChatbotSetup: false,
            supportAISetup: false,
            supportAutomationSetup: false,
            supportSpecialPanelTraining: false,
            supportConsultancy: false,
            supportIntegrationSetup: false,
            supportStrategyPlanning: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.SUPPORT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.SUPPORT, ...this.featureForm };
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.SUPPORT);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
